import React from "react";
import Search from "./components/search";
import Content from "./components/content";

const Perfomance = () => {
  return (
    <>
      <Search />
      <Content />
    </>
  );
};

export default Perfomance;
